import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import RegionSelector from './components/RegionSelector';
import Configurator from './components/Configurator';

import useSelectedRegion from './utils/selectedRegionHook';
import { fetchConfig } from './utils/configSlice';
import { ModalProvider } from './components/Modal/ModalContext';
import ModalRoot from './components/Modal/ModalRoot';
import ThanksPage from './components/ThanksScreen';

const App = () => {

  const selectedRegion = useSelectedRegion();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchConfig(selectedRegion));
  }, [dispatch, selectedRegion]);
  const { loading } = useSelector(state => state.config);

  if (loading) {
    return null;
  }

  return (
    <Router basename="/epyc-platform">
      <ModalProvider>
        <Route path="/" exact>
          { Boolean(selectedRegion) ? <Redirect to="/configurator" /> : <RegionSelector /> }
        </Route>
        <Route path="/configurator">
          { !selectedRegion ? <Redirect to="/" /> : <Configurator /> }
        </Route>
        <Route path="/thanks">
          <ThanksPage />
        </Route>
        <ModalRoot />
      </ModalProvider>
    </Router>
  );
};

export default App;
